import { render, staticRenderFns } from "./TransactionsAutoAssign.vue?vue&type=template&id=77152b4c&"
import script from "./TransactionsAutoAssign.vue?vue&type=script&lang=js&"
export * from "./TransactionsAutoAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports